// extracted by mini-css-extract-plugin
export default {"product-wrapper":"xNHoY-OJggSn8h31W9aB+Q==","product-wrapper__action":"BViaJyBWMhFaEerhWeVStQ=="};